import { Dialog, DialogActions, DialogContent, TextField, Typography } from '@mui/material';
import { MprcButton, MprcDialogTitleClose, MprcRequestErrorDialog, MprcRequestIndicator } from 'components';
import { useSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    publicationId: string;
    title: string;
    onClose: (blocked: boolean | null) => void;
}

////////////////////////////////////////////////////////////////////////////////


export const BlockDialog: React.FC<IProps> = (props) => {
    const { publicationId, title, onClose } = props;

    const { t } = useTranslation("knowledge");
    const api = useCoreApi();
    const { enqueueSnackbar } = useSnackbar();

    const [text, setText] = useState<string | null>(null);
    const [viewError, setViewError] = useState<any>(null);
    const [blocking, setBlocking] = useState<boolean>(false);

    const handleBlock = () => {
        setBlocking(true);
        api.v1.knowledgePublication.blockPublication({ publicationId, blockMessage: text }).then(result => {
            if (result.data === true) {
                enqueueSnackbar(t("Feed.Card.Actions.BlockDialog.BlockSuccessMessage"), { variant: "success" });
                onClose(true);
            }
            else {
                enqueueSnackbar(t("Feed.Card.Actions.BlockDialog.BlockFailMessage"), { variant: "error" });
            }
        }).catch(e => setViewError(e))
            .finally(() => setBlocking(false));
    }

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (<Dialog
        open
        onClose={() => onClose(null)}
        maxWidth="xs"
        fullWidth
    >
        <MprcDialogTitleClose
            title={t("Feed.Card.Actions.BlockDialog.Title")}
            subtitle={title}
            onClose={() => onClose(null)}
            shrinkPadding
        />
        <DialogContent>
            <MprcRequestIndicator type="post" visible={blocking} />
            <MprcRequestErrorDialog error={viewError} onClose={() => setViewError(null)} />
            <TextField
                autoFocus
                value={text ?? ""}
                placeholder={t("Feed.Card.Actions.BlockDialog.BlockReasonPlaceholder")}
                multiline={true}
                rows={10}
                onChange={(e) => setText(e.target.value)}
                fullWidth
                variant="outlined"
            />
            <Typography variant="caption">{t("Feed.Card.Actions.BlockDialog.BlockReasonHint")}</Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", alignItems: "center" }}>
            <MprcButton text={t("Feed.Card.Actions.BlockDialog.BlockButtonText")} variant="contained" color="warning" onClick={handleBlock} />
        </DialogActions>
    </Dialog>);
}
